export default {
  name: "PostsGrid",

  data: {
    page: 1,
    noMorePosts: false
  },

  mounted() {
    this.$options.intObserver = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry && entry.isIntersecting && !this.noMorePosts) {
        this.loadMore();
      }
    }, { threshold: 0.3 });
    this.$options.intObserver.observe(this.$refs.loadMore);
  },

  methods: {
    loadMore() {
      this.page++;
      const pageUrl = window.location.href.replace(/\d+\/$/, "") + (this.isCategory ? `page/${this.page}/` : `${this.page}/`)
      fetch(pageUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const posts = doc.querySelectorAll(".posts-grid__post");
          if (posts.length) {
            Array.from(posts).forEach(post => {
              this.$refs.posts.appendChild(post);
            });
          } else {
            this.noMorePosts = true;
          }
        });
    }
  }
}